var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireSystemsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -1.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.169 17.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.336,66.633H26.452A2.167,2.167,0,0,1,24.3,64.481v-2.79a.37.37,0,0,1,.74,0v2.79a1.42,1.42,0,0,0,1.412,1.412H40.336a1.42,1.42,0,0,0,1.412-1.412V51.27a.37.37,0,1,1,.74,0V64.481A2.124,2.124,0,0,1,40.336,66.633Z",
    transform: "translate(-24.3 -50.9)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.925 18.624)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.387,59.246a3.2,3.2,0,0,1-2.286-.941.357.357,0,0,1,.5-.5,2.516,2.516,0,0,0,3.563,0,.357.357,0,0,1,.5.5A3.2,3.2,0,0,1,20.387,59.246Z",
    transform: "translate(-18 -57.7)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.58 1.513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.333,64.385a5.477,5.477,0,0,1-3.832-1.58.357.357,0,1,1,.5-.5A4.657,4.657,0,0,0,17.3,63.679,4.521,4.521,0,0,0,20.594,62.3a.357.357,0,0,1,.5.5A5.15,5.15,0,0,1,17.333,64.385Z",
    transform: "translate(-13.4 -62.2)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.213,69.857A7.6,7.6,0,0,1,8.8,67.605a.357.357,0,0,1,.5-.5,6.98,6.98,0,0,0,9.816,0,.357.357,0,0,1,.5.5A7.547,7.547,0,0,1,14.213,69.857Z",
    transform: "translate(-8.7 -67)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.169 4.437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.023,23.7a.353.353,0,0,1-.3-.168.37.37,0,0,1,.1-.5,3.7,3.7,0,1,0-4.034,0,.364.364,0,0,1-.4.605,4.438,4.438,0,1,1,6.892-3.7,4.373,4.373,0,0,1-1.983,3.7A.508.508,0,0,1,19.023,23.7Z",
    transform: "translate(-12.4 -15.5)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.295 11.732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.944,39.688a1.244,1.244,0,1,1,1.244-1.244A1.22,1.22,0,0,1,22.944,39.688Zm0-1.782a.538.538,0,1,0,.538.538A.531.531,0,0,0,22.944,37.906Z",
    transform: "translate(-21.7 -37.2)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.169 2.488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.67,11.381a.373.373,0,0,1-.37-.37V10.07a.37.37,0,0,1,.74,0v.941A.373.373,0,0,1,24.67,11.381Z",
    transform: "translate(-24.3 -9.7)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.967 4.236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.842,16.278a.382.382,0,0,1-.269-.1l-.672-.672a.357.357,0,0,1,.5-.5l.672.672a.353.353,0,0,1-.235.605Z",
    transform: "translate(-11.8 -14.9)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.219 8.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.911,28.14H6.97a.37.37,0,0,1,0-.74h.941a.37.37,0,0,1,0,.74Z",
    transform: "translate(-6.6 -27.4)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.967 12.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.17,39.378a.382.382,0,0,1-.269-.1.366.366,0,0,1,0-.5l.672-.672a.357.357,0,0,1,.5.5l-.672.672A.305.305,0,0,1,12.17,39.378Z",
    transform: "translate(-11.8 -38)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.732 12.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.942,39.378a.382.382,0,0,1-.269-.1L35,38.605a.357.357,0,0,1,.5-.5l.672.672a.353.353,0,0,1-.235.605Z",
    transform: "translate(-34.9 -38)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.178 8.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.511,28.14H39.57a.37.37,0,1,1,0-.74h.941a.37.37,0,1,1,0,.74Z",
    transform: "translate(-39.2 -27.4)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.732 4.236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.27,16.278a.382.382,0,0,1-.269-.1.366.366,0,0,1,0-.5L35.673,15a.357.357,0,0,1,.5.5l-.672.672A.305.305,0,0,1,35.27,16.278Z",
    transform: "translate(-34.9 -14.9)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.539,19.378a8.539,8.539,0,1,1,8.539-8.539A8.551,8.551,0,0,1,8.539,19.378Zm0-16.338a7.8,7.8,0,1,0,7.8,7.8A7.8,7.8,0,0,0,8.539,3.04Z",
    transform: "translate(0 -2.3)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.339 14.467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.047,46.595a1.647,1.647,0,1,1,1.647-1.647A1.65,1.65,0,0,1,74.047,46.595Zm0-2.521a.908.908,0,1,0,.908.908A.9.9,0,0,0,74.047,44.073Z",
    transform: "translate(-72.4 -43.3)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.104 4.671)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.705,30.35a.478.478,0,0,1-.2-.067.34.34,0,0,1-.067-.5l.3-.4a5.846,5.846,0,0,0,.37-.605c2.488-4.606-1.378-9.615-2.891-11.3a7.537,7.537,0,0,1-2.353,4.572,8.755,8.755,0,0,0-1.58,2.084,5.292,5.292,0,0,0,.471,5.48.36.36,0,1,1-.571.437,6.008,6.008,0,0,1-.538-6.253,8.983,8.983,0,0,1,1.714-2.32l.034-.034a7,7,0,0,0,2.185-4.875.4.4,0,0,1,.235-.336.358.358,0,0,1,.4.067c.269.269,6.892,6.656,3.6,12.707a8.043,8.043,0,0,1-.437.706l-.3.437A.517.517,0,0,1,70.705,30.35Z",
    transform: "translate(-63.01 -16.196)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.97,40.113a.3.3,0,0,1-.168-.034,7,7,0,0,1-3.866-7.295,13.956,13.956,0,0,1,1.143-3.463,12.573,12.573,0,0,0,1.109-3.463.343.343,0,0,1,.168-.269.327.327,0,0,1,.3-.034,4.179,4.179,0,0,1,2.757,2.891.363.363,0,1,1-.706.168A3.5,3.5,0,0,0,56.86,26.4a13.574,13.574,0,0,1-1.109,3.227,13.727,13.727,0,0,0-1.076,3.261,6.323,6.323,0,0,0,.672,3.832,6.246,6.246,0,0,0,2.824,2.689.382.382,0,0,1,.168.5A.465.465,0,0,1,57.97,40.113Z",
    transform: "translate(-53.852 -25.534)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.593 4.229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.745,42.835a.37.37,0,0,1-.336-.2.363.363,0,0,1,.168-.5,7.887,7.887,0,0,0,3.9-5.782,11.333,11.333,0,0,0-.975-6.186,5.436,5.436,0,0,1-1.277,1.983.357.357,0,0,1-.5-.5,4.372,4.372,0,0,0,1.311-2.555.357.357,0,0,1,.3-.3.361.361,0,0,1,.4.2,12.514,12.514,0,0,1,1.513,7.53A8.887,8.887,0,0,1,85.913,42.8.365.365,0,0,1,85.745,42.835Z",
    transform: "translate(-85.362 -28.775)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.144 14.239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.884,62.6a.373.373,0,0,1-.37-.37A3.771,3.771,0,0,0,81.2,59.208a.36.36,0,0,1,.437-.571,4.432,4.432,0,0,1,1.614,3.631A.368.368,0,0,1,82.884,62.6Z",
    transform: "translate(-81.053 -58.553)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.748 13.965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.37,61.49h-.034a.4.4,0,0,1-.336-.4,3.843,3.843,0,0,1,2.42-3.328.362.362,0,1,1,.269.672,3.061,3.061,0,0,0-1.95,2.723A.391.391,0,0,1,65.37,61.49Z",
    transform: "translate(-65 -57.737)",
    fill: "#445862",
    stroke: "#445862",
    strokeWidth: 0.6
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireSystemsIcon);
export default __webpack_public_path__ + "static/media/fire-systems-icon.e675b964c07c6db84fcdf2dbd9068ded.svg";
export { ForwardRef as ReactComponent };